import { IEventGood } from 'meta/pages/event'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequest } from 'utils/http'

type Props = {
  codeUrl: string
}

type Response = Array<IEventGood>

export const getGoods = async (props: Props): Promise<Response> => {
  const { codeUrl } = props

  const endpoint = ApiEndpoint.event.goods(codeUrl)

  const { data } = await HttpRequest.get<Response>(endpoint)
  return data
}
